import React from "react";
import Modal from "react-bootstrap/Modal";

export default function FabricDesignNotSelectedModal({ pageLanguage, modals, modalHandleClose, t }) {
  return (
    <Modal
      dialogClassName={`warning_modal2 bigSizeModal ${
        pageLanguage === "fa" ? "font_farsi" : "font_en"
      }`}
      show={
        modals["FabricDesignNotSelected"] === undefined ? false : modals["FabricDesignNotSelected"]
      }
      onHide={() => modalHandleClose("FabricDesignNotSelected")}
    >
      <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
      <Modal.Body>
        <p className="text_center">{t("FabricDesignNotSelected")}</p>

        <br />
        <div className=" text_center">
          <button
            className=" btn btn-new-dark"
            onClick={() => modalHandleClose("FabricDesignNotSelected")}
          >
            {t("CONTINUE")}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
